import * as actionTypes from "Redux/Actions/actionTypes";

/**
 * Start loading for a given identifier.
 * - Ensures `loading` is a non-empty string.
 * - Falls back to a generic ID and message if missing.
 * @param {string} loading - A unique string ID for the loading action (e.g., 'ESIGN_CHECK_SAGA').
 * @param {string} [message] - Optional message to show during loading.
 */
export const doLoadingStart = (loading, message) => {
  const safeLoading =
    typeof loading === "string" && loading.trim() !== ""
      ? loading
      : "GENERIC_LOADING";

  const safeMessage =
    typeof message === "string" && message.trim() !== ""
      ? message
      : "Processing...";

  return {
    type: actionTypes.LOADING_START,
    loading: safeLoading,
    message: safeMessage,
  };
};

/**
 * Finish loading for a given identifier.
 * - Ensures the identifier is a string (or uses fallback if missing).
 * @param {string} loading - A unique string ID that matches the one used in doLoadingStart.
 */
export const doLoadingFinish = (loading) => {
  const safeLoading =
    typeof loading === "string" && loading.trim() !== ""
      ? loading
      : "GENERIC_LOADING";

  return {
    type: actionTypes.LOADING_FINISH,
    loading: safeLoading,
  };
};
